















import { Component, Prop, Vue } from "vue-property-decorator";
import hotkeys from "hotkeys-js";

@Component({
  name: "Cover"
})
export default class Cover extends Vue {
  mounted() {
    hotkeys("esc", ev => {
      ev.preventDefault();
      this.close();
      return false;
    });
  }

  close() {
    hotkeys.unbind("esc");
    setTimeout(() => {
      const timeset = document.getElementById("timeset");
      if (timeset !== null) {
        timeset.focus();
      }
    }, 150);
    this.$router.push("/").catch(err => {});
  }
}
